import React from 'react';
import styled from 'styled-components';
import { TYPE } from 'theme';
import application from 'stores/application';
import { observer } from 'mobx-react-lite';
import { formatNumInPhases } from 'common-helpers/utils';

const OverviewContainer = styled.div`
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    padding: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 24px;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        padding: 20px;
        flex-direction: column;
        gap: 40px;
        align-items: flex-start;
    `};
`;

const OverviewItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 100%;
    `};
`;

const LoadingSkeleton = styled.div`
    width: 60px;
    height: 32px;
    background: linear-gradient(90deg, #333 25%, #555 50%, #333 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    border-radius: 4px;

    @keyframes loading {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }
`;

const OverviewBox = observer(() => {
    const { globalStats } = application;
    const isLoading = !globalStats;

    return (
        <OverviewContainer>
            <OverviewItem>
                <TYPE.main fontSize={16} mobileFz={18} color="rgba(153, 153, 153, 1)">
                    Total Transactions
                </TYPE.main>
                <TYPE.desc fontSize={32} fontWeight={500} mobileFz={12}>
                    {isLoading ? (
                        <LoadingSkeleton />
                    ) : (
                        (() => {
                            const { fixedNum, unitSuffix } = formatNumInPhases(globalStats?.totalTransactions || 0, 1);
                            return fixedNum + unitSuffix;
                        })()
                    )}
                </TYPE.desc>
            </OverviewItem>
            <OverviewItem>
                <TYPE.main fontSize={16} mobileFz={18} color="rgba(153, 153, 153, 1)">
                    Total Participants
                </TYPE.main>
                <TYPE.desc fontSize={32} fontWeight={500} mobileFz={12}>
                    {isLoading ? (
                        <LoadingSkeleton />
                    ) : (
                        (() => {
                            const { fixedNum, unitSuffix } = formatNumInPhases(globalStats?.totalParticipants || 0, 1);
                            return fixedNum + unitSuffix;
                        })()
                    )}
                </TYPE.desc>
            </OverviewItem>
            <OverviewItem>
                <TYPE.main fontSize={16} mobileFz={18} color="rgba(153, 153, 153, 1)">
                    Total TVL
                </TYPE.main>
                <TYPE.desc fontSize={32} fontWeight={500} mobileFz={12}>
                    {isLoading ? (
                        <LoadingSkeleton />
                    ) : (
                        (() => {
                            const { fixedNum, unitSuffix } = formatNumInPhases(globalStats?.totalTvl || 0, 1);
                            return `${fixedNum}${unitSuffix} $`;
                        })()
                    )}
                </TYPE.desc>
            </OverviewItem>
        </OverviewContainer>
    );
});

export default OverviewBox;
